<script setup lang="ts">
import { useCssModule } from "vue";

import Modal from "@/components/modal/modal.vue";
import StepsButtons from "@/components/StepsButtons/StepsButtons.vue";
import useTranslate from "@/hooks/useTranslate/useTranslate";
import { useTIWStore } from "@/stores/tiw/tiw";

const classes = useCssModule();

const TIWStore = useTIWStore();

const headerText = TIWStore.IS_DISCOUNT_LATER
    ? useTranslate("tiw__thanksForOrder__headerText_ifDiscountLater")
    : useTranslate("tiw__thanksForOrder__headerText_ifNoDiscountLater");
const headerSubtext = TIWStore.IS_DISCOUNT_LATER
    ? useTranslate("tiw__thanksForOrder__headerSubtext_ifDiscountLater")
    : TIWStore.domainIsBreezyPl
      ? useTranslate("tiw__thanksForOrder__headerSubtext_ifNoDiscountLater_bpl")
      : useTranslate("tiw__thanksForOrder__headerSubtext_ifNoDiscountLater");

function goToEuro() {
    const EURO_URL = "https://www.euro.com.pl/";
    window.location.assign(EURO_URL);
}
</script>

<template>
    <Modal data-component="thanksForOrder">
        <template #header>
            <div :class="classes.header">
                <img
                    src="@/public/svg/success.svg"
                    alt="thanks for order icon"
                    width="90px"
                    height="90px"
                    :class="classes.icon"
                />
                <h2 class="tiw__h2">{{ headerText }}</h2>
                <p>{{ headerSubtext }}</p>
            </div>
        </template>

        <div>
            <b>{{ useTranslate("tiw__thanksForOrder__nextSteps") }}</b>

            <ul :class="classes.nextSteps">
                <template v-if="TIWStore.IS_DISCOUNT_LATER">
                    <li>{{ useTranslate("tiw__thanksForOrder__discountLaterList__item_1") }}</li>
                    <li>{{ useTranslate("tiw__thanksForOrder__discountLaterList__item_2") }}</li>
                    <li>
                        {{ useTranslate("tiw__thanksForOrder__discountLaterList__item_3") }}
                    </li>
                    <li>{{ useTranslate("tiw__thanksForOrder__discountLaterList__item_4") }}</li>
                    <li>
                        {{
                            TIWStore.domainIsBreezyPl
                                ? useTranslate("tiw__thanksForOrder__discountLaterList__item_5_bpl")
                                : useTranslate("tiw__thanksForOrder__discountLaterList__item_5")
                        }}
                    </li>
                </template>

                <template v-else>
                    <li>{{ useTranslate("tiw__thanksForOrder__noDiscountLaterList__item_1") }}</li>
                    <li>{{ useTranslate("tiw__thanksForOrder__noDiscountLaterList__item_2") }}</li>
                    <li>
                        {{
                            TIWStore.domainIsBreezyPl
                                ? useTranslate("tiw__thanksForOrder__noDiscountLaterList__item_3_bpl")
                                : useTranslate("tiw__thanksForOrder__noDiscountLaterList__item_3")
                        }}
                    </li>
                </template>
            </ul>
        </div>

        <StepsButtons
            no-back-btn
            :click-to-next="goToEuro"
            :btn-text="
                TIWStore.IS_DISCOUNT_LATER ? 'Wróć na stronę Euro' : 'Wykorzystaj kartę teraz'
            "
            :class="classes.stepsButtons"
        />
    </Modal>
</template>

<style module>
.header {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;

    p {
        text-align: center;
    }
}
.icon {
    margin-bottom: 14px;
}
.nextSteps {
    padding: 0;
    list-style-position: inside;
}
.stepsButtons {
    display: flex;
    justify-content: center;
}
</style>
